var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg120X120Error = function Svg120X120Error(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M95.094 47.432 79.477 15.975c-.44-.888.54-1.807 1.397-1.31l26.214 15.186a1 1 0 0 1 .337 1.411L96.828 47.533a1 1 0 0 1-1.734-.1ZM45.1 112.477l-19.604-10.292a1 1 0 0 1-.088-1.719l10.346-6.86a1 1 0 0 1 1.433.358l9.257 17.153c.469.868-.47 1.819-1.345 1.36Zm29.62-15.87 21.388-11.105c.874-.454 1.81.497 1.34 1.364L88.09 104.14a1 1 0 0 1-1.336.414l-12.03-6.17a1 1 0 0 1-.005-1.777Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M60 39.42a1 1 0 0 1 1 1v6.36a1 1 0 1 1-2 0v-6.36a1 1 0 0 1 1-1Zm0 10.6a1 1 0 0 1 1 1v6.36a1 1 0 1 1-2 0v-6.36a1 1 0 0 1 1-1Zm0 10.6a1 1 0 0 1 1 1v6.36a1 1 0 1 1-2 0v-6.36a1 1 0 0 1 1-1Zm0 10.6a1 1 0 0 1 1 1v6.36a1 1 0 1 1-2 0v-6.36a1 1 0 0 1 1-1Zm19.795-8.527a1 1 0 0 1 1.387.277l1.65 2.475a1 1 0 0 1-1.664 1.11l-1.65-2.475a1 1 0 0 1 .277-1.387ZM47.15 59a1 1 0 0 1 1-1H55a1 1 0 1 1 0 2h-6.85a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M84.402 69.834 100 59.5H78L60 33 20 59.5h22.444L60 86l24.402-16.166Z"
  })));
};
export default Svg120X120Error;